import Vue from 'vue'
import Vuex from 'vuex'
import VuexEasyFirestore from 'vuex-easy-firestore'
import { Firebase, initFirebase } from '@/firebase/init'
import authentication from './authentication'
import app from './app'
import errors from './errors'
import success from './success'
import loading from './loading'
import currentUserModule from '@/store/currentUser/currentUser'
import classroomsModule from '@/store/classrooms/classrooms'
import dates from '@/store/dates/dates'

Vue.use(Vuex)

// do the magic 🧙🏻‍♂️
const easyFirestore = VuexEasyFirestore(
  [currentUserModule, classroomsModule, dates],
  {
    logging: true,
    FirebaseDependency: Firebase
  }
)

initFirebase().catch(error => {
  // take user to a page stating an error occurred
  // (might be a connection error, or the app is open in another tab)
  console.log(error)
})

/* If you don't know about Vuex, please refer to https://vuex.vuejs.org/ */
export default new Vuex.Store({
  modules: {
    authentication,
    app,
    errors,
    success,
    loading
  },
  plugins: [easyFirestore],
  strict: false
})
